export default __webpack_public_path__ + "static/media/logo.6fd2f0c9.png";